/* globals Blob, atob, FileReader */
/*
 * Convert the DataURI to a Blob
 * @param dataURI : The dataURI to convert
 */
export function dataURItoBlob (dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
  var byteString
  if (dataURI.split(',')[0].indexOf('base64') >= 0) { byteString = atob(dataURI.split(',')[1]) } else { byteString = unescape(dataURI.split(',')[1]) }

    // separate out the mime component
  var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

    // write the bytes of the string to a typed array
  var ia = new Uint8Array(byteString.length)
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }

  return new Blob([ia], {type: mimeString})
}

/*
 * Convert a Blob to a file
 * @param theBlob : The blob to convert
 * @param filename: The filename of the file to create
 */
export function blobToFile (theBlob, fileName) {
  // A Blob() is almost a File() - it's just missing the two properties below which we will add
  theBlob.lastModifiedDate = new Date()
  theBlob.name = fileName
  return theBlob
}

/*
 * Read a file from a form / input
 */
export const readFile = ({ file }) => (callback) => {
  const reader = new FileReader()
  reader.onloadend = () => callback(file, reader.result)
  reader.readAsDataURL(file)
}



// WEBPACK FOOTER //
// ./src/utilities/blob.js